export const chat = {
  Chat: "대화",
  NewChat: "대화 생성",
  NewChatDesc: "새 대화를 시작합니다.",
  NewChatSuccess: "새 대화가 생성되었습니다.",
  EditChat: "대화 설정",
  EditChatDesc: "대화 설정을 변경합니다.",
  EditChatSuccess: "대화 설정이 변경되었습니다.",
  DeleteChat: "대화 삭제",
  DeleteChatDesc: "대화를 삭제합니다.",
  DeleteChatSuccess: "대화가 성공적으로 삭제되었습니다.",
  IsConnecting: "연결 중...",
  ConnectionLost: "연결이 끊어졌습니다. 이 곳을 클릭하여 서버에 연결하세요.",
  SelectChatToStartMessaging: "메시지를 보내려면 대화를 선택하세요.",
  SelectAdmin: "관리자 선택",
  SelectChatToShareData: "공유하려면 대화를 선택하세요.",
} as const;
